export default Object.freeze({
  startTime: 'startTime',
  endTime: 'endTime',
})
